export default __webpack_public_path__ + "static/logo-16bf5ef7f0e38780ea4a6c78104c1202.png";